import Client from "./Client";
import Payment from "Class/Payment";
import { AnyObject } from "types";

const resource = "/payments";

export default class PaymentService {
  public static async getPayments(
    page: number,
    size: number
  ): Promise<AnyObject> {
    const { data } = await Client.get(
      `${resource}?page=${page}&page_size=${size}`
    );
    return data;
  }
  public static async getPayment(paymentId: number): Promise<Payment> {
    const { data } = await Client.get(`${resource}/${paymentId}`);
    return new Payment(data.data);
  }
  public static async savePayment(payment: Payment): Promise<AnyObject> {
    const { data } = await Client.post(`${resource}`, payment.asJSON());
    return data;
  }
}
